// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__G-FAy","title":"style_title__B3TdD","text":"style_text__PXhEc","navigate":"style_navigate__5T8XA"};